import objectUtils from '../utils/object-utils'

export default class Route {
  constructor (options = {}) {
    this.model = 'Route'

    // Test Route
    this.is_test = options.is_test === true

    this.id = objectUtils.get(options, 'id', null)
    this.org_id = objectUtils.get(options, 'org_id', null)
    this.name = objectUtils.get(options, 'name', null)
    this.tracking_number = objectUtils.get(options, 'tracking_number', null)

    this.driver_user_id = objectUtils.get(options, 'driver_user_id', null)
    this.vehicle_id = objectUtils.get(options, 'vehicle_id', null)

    this.route_info = options.route_info || {}
    this.before_edit = options.before_edit

    this.odometer_reading_start = objectUtils.get(options, 'odometer_reading_start', null)
    this.odometer_reading_end = objectUtils.get(options, 'odometer_reading_end', null)
    this.notes = (options.notes && options.notes !== 'null') ? options.notes : null
    this.driver_notes = objectUtils.get(options, 'driver_notes', null)

    this.delivery_date = objectUtils.get(options, 'delivery_date', null)
    this.scheduled_start_time = objectUtils.get(options, 'scheduled_start_time', null)
    this.estimated_return_time = objectUtils.get(options, 'estimated_return_time', null)

    this.route_status = objectUtils.get(options, 'route_status', null)

    this.dispatched_at = objectUtils.get(options, 'dispatched_at', null)
    this.vehicle_claimed_at = objectUtils.get(options, 'vehicle_claimed_at', null)
    this.on_delivery_at = objectUtils.get(options, 'on_delivery_at', null)
    this.returning_to_hq_at = objectUtils.get(options, 'returning_to_hq_at', null)
    this.canceled_at = objectUtils.get(options, 'canceled_at', null)
    this.completed_at = objectUtils.get(options, 'completed_at', null)

    // Auditing
    this.created_by = objectUtils.get(options, 'created_by', null)
    this.dispatched_by = objectUtils.get(options, 'dispatched_by', null)
    this.created_at = objectUtils.get(options, 'created_at', null)
    this.updated_at = objectUtils.get(options, 'updated_at', null)

    // Associations
    if (options.orders) this.orders = options.orders
    if (options.driver) this.driver = options.driver
    if (options.vehicle) this.vehicle = options.vehicle
    if (options.vehicle_lot) this.vehicle_lot = options.vehicle_lot
    if (options.dispatcher) this.dispatcher = options.dispatcher
  }
}
